import { Box, Tooltip as MuiTooltip, styled, TooltipProps, Typography } from '@mui/material';
import { InfoIcon } from '@phosphor-icons/react';
import React from 'react';

interface CustomTooltipProps extends Omit<TooltipProps, 'title' | 'children'> {
  text: string | React.ReactNode | React.ReactElement | React.ReactElement[] | React.ReactNode[];
  children?: React.ReactNode | string | React.ReactElement | React.ReactElement[] | React.ReactNode[];
}

const StyledTooltipWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'help',
  color: theme.palette.action.active,
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(2.5),
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
    maxWidth: 300,
    fontFamily: theme.typography.fontFamily,
  },
  '& .MuiTooltip-arrow': {
    color: theme.palette.background.paper,
    '&:before': {
      border: '1px solid rgba(0, 0, 0, 0.1)',
      backgroundColor: theme.palette.background.paper,
      boxSizing: 'border-box',
    },
  },
}));

const CustomTooltip = React.forwardRef<HTMLDivElement, CustomTooltipProps>(
  function CustomTooltip({ text, children, ...props }, ref) {
    return (
      <StyledTooltip
        title={<Typography variant="body2" color="text.primary">
          {text}
        </Typography>
        }
        arrow
        placement="top"
        enterDelay={300}
        leaveDelay={200}
        {...props}
      >
        <StyledTooltipWrapper ref={ref}>
          {children || <InfoIcon size={16} />}
        </StyledTooltipWrapper>
      </StyledTooltip>
    );
  }
);

export default CustomTooltip; 